'use strict';

angular.module('shiftTraderApp')
    .controller('OrganizationSetupWizardCtrl', function ($scope, $uibModalInstance, $state, params, allUsers, EventTrackingService,
                                                         OrganizationSettings, $interval, $timeout, ServerUrls, Session, Angularytics) {
      $scope.me = params.me;
      $scope.serverUrl = ServerUrls.current.railsApi;
      $scope.access_token = Session.getAccessToken();
      $scope.modalInstance = $uibModalInstance;
      $scope.org = params.org;
      $scope.allPositions = params.allPositions;
      var detectTemplateLoadedInterval;
      var animationDuration = 400;
      $scope.allUsers = allUsers;

      $scope.sections = {
        organization: {
          formData: {},
          state: {}
        },
        departments: {
          formData: {},
          state: {
            hasDepartments: false,
            currView: 0,
            q: {}
          }
        },
        positions: {
          formData: {},
          state: {}
        },
        employees: {
          formData: {},
          state: {
            currView: 0,
            q: {}
          }
        },
        empPositions: {
          formData: {},
          state: {}
        },
        availability: {
          formData: {},
          state: {}
        }
      };

      $scope.sections.departments.advanceView = function() {
        if ($scope.sections.departments.state.currView === 0) {
          if ($scope.sections.departments.displayEditor) {
            $scope.sections.departments.state.currView = 2;
          } else {
            $scope.sections.departments.state.currView = 1;
          }

        } else if ($scope.sections.departments.state.currView === 1) {
          $scope.sections.departments.state.currView = 2;
        }
      };

      $scope.sections.departments.decrementView = function() {
        if ($scope.sections.departments.state.currView === 2) {
          if ($scope.sections.departments.displayEditor) {
            $scope.sections.departments.state.currView = 0;
          } else {
            $scope.sections.departments.state.currView = 1;
          }
        } else if ($scope.sections.departments.state.currView === 1) {
          $scope.sections.departments.state.currView = 0;
        }
      };

      $scope.sections.departments.state.q.isCurrentView = function(view) {
        return $scope.sections.departments.state.currView === view;
      };

      $scope.sections.departments.setView = function(view) {
        $scope.sections.departments.state.currView = view;
      };

      $scope.sections.employees.state.q.isCurrentView = function(view) {
        return $scope.sections.employees.state.currView === view;
      };

      $scope.sections.employees.setView = function(view) {
        $scope.sections.employees.state.currView = view;
      };

      $scope.sectionTitles = [
        {
          name: 'Organization',
          machineName: 'organization'
        },
        {
          name: 'Departments',
          machineName: 'departments'
        },
        {
          name: 'Positions',
          machineName: 'positions'
        },
        {
          name: 'Employees',
          machineName: 'employees'
        },
        {
          name: 'Assign Positions',
          machineName: 'empPositions'
        },
        {
          name: 'Final Steps',
          machineName: 'availability'
        }
      ];

      Angularytics.trackEvent('GettingStarted', 'org-setup-wizard', 'opened');

      $scope.preloadWizard = function(currentState) {
        window.logTime('preloadWizard', currentState);
        // TODO: set these dynamically
        $scope.currentState = currentState;
        $scope.newState = currentState;

        $scope.sections.organization.state = {
          modified: false
        };

        var orgConfig = $scope.org.organization_config;
        if (!_.isNull(orgConfig.default_training_hourly_wage)) {
          $scope.sections.organization.formData = {
            startDayOfWeek: orgConfig.work_week_start || 1,
            workDayStartHour: orgConfig.work_day_start_hour || 0,
            estimatedLaborCost: orgConfig.hourly_rate_for_estimates || '',
            startingPayRate: orgConfig.starting_pay_rate || '',
            timezone: orgConfig.timezone || 'Eastern Time (US & Canada)'
          };
        } else {
          $scope.sections.organization.formData = {
            startDayOfWeek: 1,
            workDayStartHour: 0,
            estimatedLaborCost: '',
            startingPayRate: '',
            timezone: 'Eastern Time (US & Canada)'
          };
        }

        if (_.isNull(orgConfig.onboarding_wizard_started_at)) {
          var data = {
            organization_id: $scope.org.id,
            onboarding_wizard_started_at: moment.utc().format()
          };

          OrganizationSettings.create(data);
        }

        window.logTime('pre cloneDeep');
        $scope.sections.employees.newUsers = _.clone($scope.allUsers);

        window.logTime('cp1');
        $scope.sections.departments.newDepartments = _.cloneDeep($scope.org.departments);
        window.logTime('after 2nd cloneDeep');

        $scope.sections.departments.displayEditor = hasActiveDepartments();

        // this overrides as if you didnt have any departments yet
        $scope.sections.departments.displayEditor = false;

        detectTemplateLoadedInterval = $interval(function() {
          window.logTime('interval fired in orgWizard');
          if( $('.modal_wizard_slide_wrapper').length > 0 ) {
            $scope.goToState($scope.currentState, true);
          }
        }, 50);
      };

      $scope.sections.organization.timezoneMapping = [
        {
          name: 'Pacific Time (PDT)',
          value: 'Pacific Time (US & Canada)'
        },
        {
          name: 'Mountain Time (MDT)',
          value: 'Mountain Time (US & Canada)'
        },
        {
          name: 'Central Time (CDT)',
          value: 'Central Time (US & Canada)'
        },
        {
          name: 'Eastern Time (EDT)',
          value: 'Eastern Time (US & Canada)'
        }
      ];

      $scope.sections.organization.daySettingMapping = [
        {
          name: 'Sunday',
          value: 0
        },
        {
          name: 'Monday',
          value: 1
        },
        {
          name: 'Tuesday',
          value: 2
        },
        {
          name: 'Wednesday',
          value: 3
        },
        {
          name: 'Thursday',
          value: 4
        },
        {
          name: 'Friday',
          value: 5
        },
        {
          name: 'Saturday',
          value: 6
        }
      ];

      $scope.sections.organization.dayHourStart = [
        {
          name: '12:00am',
          value: 0
        },
        {
          name: '1:00am',
          value: 1
        },
        {
          name: '2:00am',
          value: 2
        },
        {
          name: '3:00am',
          value: 3
        },
        {
          name: '4:00am',
          value: 4
        },
        {
          name: '5:00am',
          value: 5
        },
        {
          name: '6:00am',
          value: 6
        }
      ];

      $scope.sections.organization.formChoice = 0;

      $scope.sections.organization.selectHint = function(hint) {
        $scope.sections.organization.formChoice = hint;
      };

      $scope.sections.organization.isSelectedHint = function(hint) {
        return $scope.sections.organization.formChoice === hint;
      };

      $scope.sections.organization.updateServer = function() {
        if ($scope.sections.organization.state.modified) {
          var data = {};
          data.organization_id = $scope.org.id;
          data.work_week_start = $scope.sections.organization.formData.startDayOfWeek;
          data.work_day_start_hour = $scope.sections.organization.formData.workDayStartHour;
          data.default_training_hourly_wage = $scope.sections.organization.formData.estimatedLaborCost;
          data.overtime_threshold_hours = $scope.sections.organization.formData.startingPayRate;
          data.timezone = $scope.sections.organization.formData.timezone;

          return OrganizationSettings.create(data)
              .then(function (response) {
                //flash.success = $scope.textName + ' updated!';
                $scope.sections.organization.state.modified = false;
                return response;
              }, function () {
                //flash.error = $scope.textName + ' did not update correctly. Please try again.';
                return undefined;
              });
        }
      };

      $scope.sections.employees.hasNewEmployee = function() {
        return _.findIndex($scope.sections.employees.newUsers, function(emp) {
          return emp.memberships[0].active;
        }) > -1;
      };

      $scope.sections.positions.updateSaveStatus = function(val) {
        $scope.sections.positions.savedStatus = val;
      };

      $scope.goToNext = function() {
        if($scope.currentState === 0) {
          $scope.sections[$scope.sectionTitles[$scope.currentState].machineName].updateServer();
        }
        $scope.goToState($scope.currentState + 1);
      };

      $scope.goToPrev = function() {
        $scope.goToState($scope.currentState - 1);
      };

      var transitionTimeout;
      var animationTimeout;

      $scope.goToState = function(newState, goNow) {
        window.logTime('goToState', newState, goNow);
        if (newState < 0) {
          newState = 0;
        }

        $scope.newState = newState;
        if (newState === 3) {
          $scope.sections.employees.setView(0);
        }

        if (newState === 1) {
          // preset back to 0 if going back or forward to Departments section
          $scope.sections.departments.setView(0);
        }

        if (!_.isUndefined(detectTemplateLoadedInterval)) {
          $interval.cancel(detectTemplateLoadedInterval);
          detectTemplateLoadedInterval = undefined;
        }

        // Wait for a small amount of time before animating to
        // allow the target slide directive to instantiate
        animationTimeout = $timeout(function () {
          if (!_.isUndefined(goNow)) { // If we loaded to a specific state, do not animate
            $('.modal_wizard_slide_wrapper').css({
              left: newState * -1000
            });
          } else { // If we clicked a button, animate
            $('.modal_wizard_slide_wrapper').animate({
                left: newState * -1000
              }, animationDuration);
          }
        }, 50);

        // Create transitioning timer so current slide doesn't
        // disappear at start of animation
        if (!_.isUndefined(transitionTimeout)) {
          $timeout.cancel(transitionTimeout);
        }
        transitionTimeout = $timeout(function () {
          $scope.currentState = newState;

          var data = {
            organization_id: $scope.org.id,
            onboarding_wizard_state: newState
          };

          OrganizationSettings.create(data);
          EventTrackingService.addEvent('orgSetupWizard slide ' + $scope.sectionTitles[newState].name);
          Angularytics.trackEvent('GettingStarted', 'org-setup-wizard', $scope.sectionTitles[newState].name, newState);
        }, animationDuration);

      };

      $scope.hasBasicOrgInfo = function() {
        return $scope.sections.organization.formData.estimatedLaborCost > 0 &&
               $scope.sections.organization.formData.startingPayRate > 0;
      };

     $scope.close = function() {
       $uibModalInstance.close('close');
     };

      $scope.sections.departments.setDepartments = function(useDepartments) {
        $scope.sections.departments.state.hasDepartments = useDepartments;
      };

      $scope.displaySlide = function(slide) {
        return $scope.currentState === slide || $scope.newState === slide;
      };

      $scope.hasActivePositions = function() {
        return _.where($scope.allPositions, { active: true }).length;
      };

      var hasActiveDepartments = function() {
        return _.where($scope.org.departments, { active: true }).length;
      };

      $scope.wizardComplete = function() {
        var data = {
          organization_id: $scope.org.id,
          onboarding_wizard_completed_at: moment.utc().format()
        };

        OrganizationSettings.create(data);

        if (_.isNull($scope.org.organization_config.onboarding_wizard_completed_at)) {
          $state.go('manageWorkPeriods.date');
        }

        $timeout(function() {
          $uibModalInstance.close('finished wizard');
        }, 1000);
      };

      console.log($scope.org.organization_config.onboarding_wizard_state || 0);
      $scope.preloadWizard($scope.org.organization_config.onboarding_wizard_state || 0);

    });
